export const COOKIE_MAX_AGE_1_YEAR = 365 * 24 * 60 * 60
export const BREADCRUMB_DISPLAY = 3
export const SUPERADMIN_ID = 1
export const ADMIN_ID = 2
